<template>
    <v-dialog :value="value" max-width="600px" persistent scrollable>
        <v-card color="kbLight">
            <v-toolbar color="kbBlue" dark flat>
                <v-toolbar-title>
                    Acortar enlace
                </v-toolbar-title>

                <v-spacer/>

                <v-btn @click="toggleModal()"
                       icon>
                    <v-icon>
                        clear
                    </v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-form lazy-validation
                        ref="shortLinkForm"
                        v-model="valid">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Enlace"
                                          color="kbDarkBlue"
                                          :rules="[rules.required]"
                                          v-model="url">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea label="Descripción"
                                        color="kbDarkBlue"
                                        outlined
                                        v-model="info.description">
                            </v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-btn block
                                   @click="submit()"
                                   color="kbBlue"
                                   dark
                                   :loading="loading">
                                Acortar enlace
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <v-row v-if="shortLinks.length > 0">
                    <v-col cols="12">
                        <v-list two-line>
                            <v-subheader class="px-0 font-weight-bold primary--text">Enlaces acortados</v-subheader>
                            <template v-for="(link, i) in shortLinks">
                                <v-list-tile :key="i">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{link.shortUrl}}
                                        </v-list-tile-title>

                                        <v-list-tile-sub-title>
                                            {{link.url}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn @click="copyText(link.shortUrl)"
                                                       icon
                                                       color="primary"
                                                       flat
                                                       v-on="on">
                                                    <v-icon>
                                                        file_copy
                                                    </v-icon>
                                                </v-btn>
                                            </template>

                                            <span>Copiar enlace</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-divider v-if="i < shortLinks.length - 1" :key="i + '-divider'"/>
                            </template>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn @click="toggleModal()"
                       color="error"
                       outlined>
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import notifications from '@/libs/notifications.js'
import rules from '@/libs/rules.js'
export default {
  data: () => ({
    info: {
      description: ''
    },
    shortLinks: [],
    loading: false,
    rules,
    url: '',
    valid: true
  }),
  methods: {
    async submit () {
      try {
        if (!this.$refs.shortLinkForm.validate()) return

        this.loading = true
        const request = {
          data: {
            url: this.url,
            info: this.info
          },
          method: 'POST',
          url: 'https://keybe.bio/s/create'
        }

        request.data.info.app = this.$store.getters.appUuid

        const response = await axios(request)
        this.shortLinks.push({
          shortUrl: response.data.shortUrl,
          url: response.data.url
        })
        this.$refs.shortLinkForm.reset()
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    copyText (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success('Datos copiados en el portapapeles')
      }).catch(() => {
        notifications.error('Ocurrió un error, intenta nuevamente')
      })
    },
    toggleModal () {
      this.shortLinks = []
      this.$refs.shortLinkForm.reset()
      this.$emit('input', false)
    }
  },
  props: ['value']
}
</script>
